import styled from 'styled-components';

import { CancelButtonContainerProps, InlineFormButtonsProps } from './InlineFormButtons.decl';

import { Box, Button, Spacer } from '@aircall/tractor';
import { SaveButton } from '@components/Button/SaveButton';
import { getSavingStatus } from '@components/ModalForm/utils/getSavingStatus';
import { useRouteChangePrompt } from '@hooks/useRouteChangePrompt';
import { useTranslation } from 'react-i18next';

/* istanbul ignore next */
const CancelButtonContainer = styled(Box)<CancelButtonContainerProps>`
  visibility: ${({ visible }) => (visible ? 'hidden' : 'initial')};
`;

export function InlineFormButtons<FormValues, InitialFormValues>({
  submitting,
  onCloseClick,
  shouldDisableSubmit,
  handleSubmit,
  formRenderProps,
  submitButtonText,
  shouldBlockNavigation = false,
}: InlineFormButtonsProps<FormValues, InitialFormValues>) {
  const { t } = useTranslation();
  const { pristine } = formRenderProps;

  useRouteChangePrompt(
    // only block the navigation if the form values are changed
    shouldBlockNavigation && !pristine
  );

  return (
    <Spacer space='xxs'>
      <CancelButtonContainer visible={submitting}>
        <Button
          onClick={onCloseClick}
          type='button'
          mode='outline'
          size='small'
          data-test='inline-form-cancel-button'
        >
          {t('app.form.buttons.cancel')}
        </Button>
      </CancelButtonContainer>
      <SaveButton
        type='submit'
        size='small'
        disabled={shouldDisableSubmit}
        onClick={handleSubmit}
        data-test='inline-form-submit-button'
        status={getSavingStatus(formRenderProps)}
        content={submitButtonText ?? t('app.form.buttons.submit')}
      />
    </Spacer>
  );
}
